var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillCoinGy2Lg = function SvgFillCoinGy2Lg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    fill: "none",
    viewBox: "0 0 61 60"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 24.375,
    fill: "#E3E6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8CED4",
    d: "m41.006 25.915.815-2.818a.4.4 0 0 0-.384-.511h-3.325a.4.4 0 0 0-.39.31l-2.556 11.058-2.829-11.067a.4.4 0 0 0-.387-.301h-2.913a.4.4 0 0 0-.387.3l-2.843 11.068-2.542-11.058a.4.4 0 0 0-.39-.31H19.55a.4.4 0 0 0-.384.511l.816 2.818h-3.645a.4.4 0 0 0-.4.4v2.923c0 .22.18.4.4.4h4.71l2.691 9.375a.4.4 0 0 0 .385.29h3.034a.4.4 0 0 0 .384-.288l2.953-10.166 2.953 10.166a.4.4 0 0 0 .384.288h3.048a.4.4 0 0 0 .384-.29l2.677-9.375h4.71a.4.4 0 0 0 .4-.4v-2.923a.4.4 0 0 0-.4-.4z"
  })));
};
export default SvgFillCoinGy2Lg;